









































































import { Component, Vue, Prop } from 'nuxt-property-decorator';

import BravadoText from '@/components/common/BravadoText/BravadoText.vue';

import CheckIcon from '@/assets/svg/check-circle.vue.svg';
import MinusIcon from '@/assets/svg/minus-circle.vue.svg';
import UserIcon from '@/assets/svg/user-plus.vue.svg';

import { distanceToNow } from '@/components/utils/core/date';

import { ConnectionStatus } from '@/components/partials/public-portfolio/PublicPortfolioConnectionActions/types';
import type { Connection } from '@/components/global/HeaderMenu/HeaderMenuConnections/types';

@Component<HeaderMenuConnectionsCard>({
  name: 'HeaderMenuConnectionsCard',
  components: { BravadoText, CheckIcon, MinusIcon, UserIcon },
})
export default class HeaderMenuConnectionsCard extends Vue {
  @Prop({ required: true }) connection!: Connection;
  @Prop({ required: true }) onReadConnectionRequest!: (id: string) => Promise<void>;

  get requestDescription(): string {
    switch (this.connection.status) {
      case ConnectionStatus.accepted: {
        return 'request was accepted';
      }
      case ConnectionStatus.rejected: {
        return 'request was declined';
      }
      default: {
        return 'wants to connect with you';
      }
    }
  }

  get userInitials(): string {
    return this.connection.requestor
      ? this.getInitial(this.connection.requestor.firstName) + this.getInitial(this.connection.requestor.lastName)
      : '';
  }

  get cardClass(): Record<string, boolean> {
    return {
      'header-menu-connections-card': true,
      'header-menu-connections-card--unread': !this.connection.read,
    };
  }

  get markClass(): Record<string, boolean> {
    return {
      'header-menu-connections-card__mark': true,
      [`header-menu-connections-card__mark--${this.connection.status}`]: true,
    };
  }

  get markIcon(): string {
    switch (this.connection.status) {
      case ConnectionStatus.accepted: {
        return 'CheckIcon';
      }
      case ConnectionStatus.rejected: {
        return 'MinusIcon';
      }
      default: {
        return 'UserIcon';
      }
    }
  }

  get createdAgo(): string {
    const connectionDate = new Date(this.connection.createdAt);

    if ((Date.now() - connectionDate.getTime()) / 1000 < 60) return 'Just now';

    return `${distanceToNow(connectionDate)} ago`;
  }

  getInitial(value: string): string {
    return value.substring(0, 1);
  }

  onAcceptConnection() {
    this.$analytics.logEvent('header__notifications__connection_card__accept__button__click');

    return this.$emit('accept', this.connection.id, this.connection.requestor?.slug);
  }

  onDeclineConnection() {
    this.$analytics.logEvent('header__notifications__connection_card__decline__button__click');

    return this.$emit('decline', this.connection.id, this.connection.requestor?.slug);
  }

  onOpenReference() {
    this.$analytics.logEvent('header__notifications__connection_card__portfolio__button__click');

    if (!this.connection.read) {
      this.onReadConnectionRequest(this.connection.id);
    }

    if (
      this.connection.requestor &&
      (this.$route.name !== this.$pages.PORTFOLIO_SLUG_PAGE.name ||
        this.$route.params?.slug !== this.connection.requestor.slug)
    ) {
      this.$utils.redirectWithQuery(this.$pages.PORTFOLIO_SLUG_PAGE, {
        params: { slug: this.connection.requestor.slug },
      });
    }
  }
}
